import formAddressFieldsMixin from '@phoenix/mixins/formAddressFieldsMixin';
import formBasicMixin from '@phoenix/mixins/formBasicMixin';

import FormGroup from '@maison/components/form/FormGroup';
import TextField from '@maison/components/form/fields/TextField';
import SelectField from '@maison/components/form/fields/SelectField';
import { defineAsyncComponent } from 'vue';
import { emitter, NEWSLETTER_SUBSCRIBED } from '@phoenix/event-bus';

export default {
  components: {
    PhoenixForm: defineAsyncComponent(() => import('@maison/components/form/PhoenixForm.vue')),
    FormGroup,
    TextField,
    SelectField,
  },

  mixins: [formBasicMixin, formAddressFieldsMixin],

  props: {
    redirectUrl: {
      type: String,
      required: false,
      default: '',
    },
    enableCaptcha: {
      type: Boolean,
      default: true,
    },
    enableEmailConfirmation: {
      type: Boolean,
      default: false,
    },
    shouldResetFormOnSubmit: {
      type: Boolean,
      default: false,
    },
    showErrorsInToast: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      formConfigName: 'newsletter',
      values: {},
    };
  },

  computed: {
    action() {
      return window.route('api.form.newsletter.post');
    },
  },

  created() {
    this.setFields({
      country: {
        id: 'country',
        name: 'country',
        label: this.$t('Form.label.country'),
        value: null,
        options: [],
        required: true,
      },
    });

    if (this.enableEmailConfirmation) {
      this.setFields({
        emailConfirmation: {
          id: 'emailConfirmation',
          name: 'email_confirmation',
          label: this.$t('Form.emailConfirmation'),
          value: '',
          required: true,
          type: 'email',
        },
      });
    }
  },

  methods: {
    async addTrackingInformation() {
      const email = this.fields.email.value || '';
      const event = await window.tracking.getNewsletterSubscriptionTracking(email);
      window.tracking.pushEvent(event);
      emitter.emit(NEWSLETTER_SUBSCRIBED);
    },
  },
};
